<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'CONTRACT_CANCEL.TITLE' | translate }}</h3>
  <div class="text-center">
    <div class="finish text-center">
      {{ 'RESEND.FINISH_TEXT_1' | translate }}<br>{{ 'RESEND.FINISH_TEXT_2' | translate }}
    </div>
    <div class="text-center">
      <div class="col-12">
        <div class="display finish2">
          <a (click)="back()"  class="btn-grey">
            {{ 'RESEND.FINISH_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>     
</div>